/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button, Typography, LinearProgress } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(2),
  },
}));

// COMPONENT
function CourtListToolbar({ isLoading, disabled, onAdd }) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <Typography variant="overline" gutterBottom>
          Quadras
        </Typography>
        <span className={classes.spacer} />

        <Button color="primary" variant="contained" onClick={onAdd} disabled={disabled}>
          Adicionar Quadra
        </Button>
      </div>
      <div style={{ marginTop: '5px' }}>
        {isLoading ? <LinearProgress style={{ width: '100%' }} /> : <div style={{ height: '4px' }} />}
      </div>
    </div>
  );
}

export default CourtListToolbar;
